import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService, HttpMethod} from '../../base-api.service';
import {RecipesCostingModelService} from '../../../Models/YuChef/Recipes-costing/recipes-costing-model.service';
import {RecipeCostingFilters} from '../../../../Models/YuChef/Recipes-costing/recipe-costing-filters.model';
import {RecipeCostingStepForm} from '../../../../Models/YuChef/Recipes-costing/recipe-costing-step-store.model';
import {RecipeCostingIngredientForm} from '../../../../Models/YuChef/Recipes-costing/recipe-costing-ingredient-store.model';
import {RecipeCostingForm} from '../../../../Models/YuChef/Recipes-costing/recipe-costing-store.model';

@Injectable({
  providedIn: 'root'
})
export class RecipesCostingApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: RecipesCostingModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las fichas técnicas
   *
   */
  public getRecipesCosting(filters: RecipeCostingFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getEscandallos', {...filters, compuesto: 1}).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener una ficha técnica
   *
   */
  public getRecipeCostingDetail(params: { id: number, local: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getEscandallo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar ficha técnica
   *
   */
  public setRecipeCosting(params: RecipeCostingForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? 'kitchen/product-data-sheets/' + params.id : 'kitchen/product-data-sheets';
    const formData = params.asFormData();

    if (params.id) {
      formData.append('_method', 'PATCH');
    }

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, formData, 'post').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Eliminar ficha técnica
   *
   */
  public deleteRecipeCosting(id: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`kitchen/product-data-sheets/${id}`, {}, 'delete').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar ingrediente ficha técnica
   *
   */
  public setRecipeCostingIngredient(recipeCostingId: number, params: RecipeCostingIngredientForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? `kitchen/product-data-sheets/${recipeCostingId}/ingredients/${params.id}` : `kitchen/product-data-sheets/${recipeCostingId}/ingredients`;
    const method: HttpMethod = params.id ? 'patch' : 'post';

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, params, method).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Eliminar un ingrediente de la ficha técnica
   *
   */
  public deleteIngredient(recipeCostingId: number, ingredientId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`kitchen/product-data-sheets/${recipeCostingId}/ingredients/${ingredientId}`, {}, 'delete').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar paso de una ficha técnica
   *
   */
  public setRecipeCostingStep(recipeCostingId: number, params: RecipeCostingStepForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? `kitchen/product-data-sheets/${recipeCostingId}/steps/${params.id}` : `kitchen/product-data-sheets/${recipeCostingId}/steps`;
    const method: HttpMethod = params.id ? 'patch' : 'post';

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, params, method).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Eliminar paso de una ficha técnica
   *
   */
  public deleteStep(recipeCostingId: number, stepId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`kitchen/product-data-sheets/${recipeCostingId}/steps/${stepId}`, {}, 'delete').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }

}
